import { Inject, Injectable } from '@angular/core';
import {
  ProductStockEntry,
  ProductStockEntryRepository
} from '@infrab4a/connect';
import { PageContent } from 'src/app/components/table';
import { ConnectRequest } from 'src/app/models';
import { BaseConnectService } from './base-connect.service';

@Injectable({
  providedIn: 'root'
})
export class ShopProductStockEntryService extends BaseConnectService<ProductStockEntry> {
  constructor(
    @Inject('ProductStockEntryRepository')
    private stockEntryRepository: ProductStockEntryRepository
  ) {
    super(stockEntryRepository);
  }

  async getStockEntriesList(
    request: Partial<ConnectRequest>
  ): Promise<PageContent<Partial<ProductStockEntry>>> {
    const fields = [
      'id',
      'productId',
      'codProduct',
      'productDescription',
      'eventDescription',
      'invoiceValue',
      'price',
      'quantity',
      'invoiceId',
      'nfeKey',
      'batch',
      'createdAt'
    ];

    const result = await this.paginatedSearch({
      ...request,
      fields,
      sortBy: 'createdAt',
      sortDirection: 'desc'
    });
    const content = result.data.map((entry) => ({ ...entry }));
    const totalPages = request.pageSize
      ? Math.floor(result.count / request.pageSize)
      : undefined;

    return {
      totalPages,
      totalElements: result.count,
      content,
      empty: result.count === 0
    };
  }

  override get scheme(): 'firebase' | 'hasura' {
    return 'hasura';
  }
}
